export function normalizeError(errorObj: any) {
  if (!errorObj) return {};

  const { response, message } = errorObj;
  let error;

  if (!response) {
    console.error(
      `Received error ${message} while trying to communicate with the backend`
    );
    error = {
      detail: "Une erreur est survenue. Veuillez contacter l'équipe de support",
    };
  } else {
    const { data } = response;
    if (data?.errors) {
      error = data.errors;
    } else if (data?.detail) {
      error = { detail: data.detail };
    } else {
      error = {
        detail: "Une erreur est survenue. Veuillez réessayer plus tard",
      };
    }
  }

  return { ...error };
}
